import { migrateSellerSession } from "./axios_Interceptor/authSession";
import { StatePage } from "./UI/ContentState";
import { useEffect, useState } from "react";

import axios from "axios";

import url from "./server";



export default function AuthCallback() {

  const [error, setError] = useState("");

  const [refreshToken] = useState(() => new URLSearchParams(window.location.search).get("refreshToken"));

  useEffect(() => {

    const clean = new URL(window.location.href);

    ["accessToken", "refreshToken", "ssoToken"].forEach(key => clean.searchParams.delete(key));

    window.history.replaceState({}, "", clean.pathname + clean.search);

    let active = true;

    migrateSellerSession();
    axios.post(url.Communication_url.refresh, { refreshToken }, { withCredentials: true, headers: { "X-Fanbird-Session": "customer" } })

      .then(res => {

        if (!active) return;

        if (!res.data.newRefreshToken) throw new Error("인증 결과가 없습니다.");

        sessionStorage.setItem("key", res.data.newRefreshToken);

        localStorage.removeItem("key");

        sessionStorage.removeItem("authority");

        localStorage.removeItem("authority");

        const destination = sessionStorage.getItem("authReturnTo") || "/";

        sessionStorage.removeItem("authReturnTo");

        window.location.replace(destination.startsWith("/") && !destination.startsWith("//") && !/[\\\t\r\n]/.test(destination) ? destination : "/");

      })

      .catch(() => { if (active) setError("로그인 인증에 실패했습니다. 다시 로그인해주세요."); });

    return () => { active = false; };

  }, [refreshToken]);

  return <StatePage label="로그인" kind={error ? "error" : "loading"} icon="account" title={error || "로그인 확인 중입니다."} description={error ? "홈 화면에서 다시 로그인해 주세요." : "로그인이 완료되면 이전 화면으로 이동해요."} action={error ? { label: "홈으로", href: "/" } : undefined} />;
}

